import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { RestoredListenerEvent } from '@capacitor/app';
import { Preferences } from '@capacitor/preferences';

@Injectable({
  providedIn: 'root'
})
export class AppResumeService {

  private _hasData: boolean = false;
  public get hasData(): boolean {
    return this._hasData;
  }
  private _restoredState: RestoredListenerEvent;

  constructor(
    private router: Router,
    private zone: NgZone,
  ) { }

  public async saveState() {
    const location = this.router.url;
    await Preferences.set({
      key: 'lastAppLocation',
      value: location
    });
  }

  public async resetState() {
    await Preferences.remove({
      key: 'lastAppLocation'
    });
    this._hasData = false;
    this._restoredState = null;
  }

  public async restoreAppState(state: RestoredListenerEvent) {
    this._restoredState = state;
    if (this._restoredState.success) {
      this._hasData = true;
      const location = await Preferences.get({ key: 'lastAppLocation' });
      if (location?.value) {
        console.log(`Restored state from ${this._restoredState.pluginId}.${this._restoredState.methodName}() for ${location.value}`);
        this.zone.run(() => {
          return this.router.navigateByUrl(location.value);
        });
      }
      else {
        console.log(`Restored state from ${this._restoredState.pluginId} without saved location, ignoring`);
      }
    }
    else {
      console.log(`Restored state error from ${this._restoredState.pluginId}, error ${this._restoredState.error}`);
      this.resetState();
    }
  }

  public getData() {
    return this._restoredState.data;
  }

}
